export const API_PORT = "https://yashblogapi.onrender.com/"
// export const API_PORT = "http://localhost:4000/"
export const SHARE_URL = "%20https%3A%2F%2Fyashblog.vercel.app%2F%23%2Fpost%2F"